import jwtService from "services/jwtService";
import { setUserData } from "./user.actions";

export const CONFIRM_FETCH_START = "CONFIRM_FETCH_START";
export const CONFIRM_FETCH_SUCCESS = "CONFIRM_FETCH_SUCCESS";
export const CONFIRM_FETCH_FAILURE = "CONFIRM_FETCH_FAILURE";

export function submitConfirm({ code, url, onSuccess, onError }) {
  return (dispatch, getState) => {
    dispatch({
      type: CONFIRM_FETCH_START,
    });

    const { auth } = getState();

    jwtService
      .registerConfirm({
        user_id:
          url === "register"
            ? auth.register.data.user_id
            : auth.forgot.data.user_id,
        code,
        url,
      })
      .then((response) => {
        url === "register" && dispatch(setUserData(response));
        onSuccess();
        console.log(response);
        return dispatch({
          type: CONFIRM_FETCH_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        onError();
        return dispatch({
          type: CONFIRM_FETCH_FAILURE,
          payload: error,
        });
      });
  };
}
